"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const gatsby_plugin_image_1 = require("gatsby-plugin-image");
const React = __importStar(require("react"));
var BashLogo = function BashLogo() { return /*#__PURE__*/ React.createElement(gatsby_plugin_image_1.StaticImage, { alt: "Bash", height: 32, src: "../../images/logos/bash.svg", __imageData: require("/home/runner/work/engineering.tracmap.com/engineering.tracmap.com/.cache/caches/gatsby-plugin-image/2106929867.json") }); };
exports.default = BashLogo;
